function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 2.4c-.3-.2-.8-.2-1.1 0L4.3 5.8c-.2.1-.4.2-.6.2H2v2h1c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H2v2h16v-2h-1c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h1V6h-1.7c-.2 0-.4-.1-.6-.2l-5.1-3.4zM14 9c0-.6-.4-1-1-1h-1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V9zM8 8c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgBank;